/* oxlint-disable max-lines */
// App-owned names mapped to the Font Awesome icons they render.
// The icon objects are imported directly, so a name can never point at an icon that
// was never registered: a typo is a build error, not a blank icon at runtime.
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowDownWideShort,
  faArrowUp,
  faBan,
  faBullhorn,
  faCalendarDays,
  faChartBar,
  faCheckDouble,
  faChevronLeft,
  faChevronUp,
  faCircle,
  faCircleMinus,
  faCodeBranch,
  faComments,
  faCompress,
  faDatabase,
  faDownload,
  faEnvelopeOpenText,
  faExpand,
  faFile,
  faFileAudio,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileSignature,
  faFileVideo,
  faFileWord,
  faForward,
  faImages,
  faLaughBeam,
  faLinkSlash,
  faPaperPlane,
  faPoll,
  faRightFromBracket,
  faRobot,
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faBars as fasBars,
  faBolt as fasBolt,
  faBuilding as fasBuilding,
  faCalendar as fasCalendar,
  faCheck as fasCheck,
  faChevronDown as fasChevronDown,
  faChevronRight as fasChevronRight,
  faCircleQuestion as fasCircleQuestion,
  faCircleXmark as fasCircleXmark,
  faComment as fasComment,
  faCreditCard as fasCreditCard,
  faEllipsis as fasEllipsis,
  faEllipsisVertical as fasEllipsisVertical,
  faEnvelope as fasEnvelope,
  faExclamationCircle as fasExclamationCircle,
  faFileLines as fasFileLines,
  faFolderOpen as fasFolderOpen,
  faHandshake as fasHandshake,
  faShare,
  faHouse as fasHouse,
  faInfo as fasInfo,
  faLayerGroup as fasLayerGroup,
  faLink as fasLink,
  faList as fasList,
  faLocationDot as fasLocationDot,
  faLock as fasLock,
  faMinus as fasMinus,
  faPenToSquare as fasPenToSquare,
  faSpinner,
  faPlus as fasPlus,
  faSave as fasSave,
  faTag as fasTag,
  faTimeline as fasTimeline,
  faTrashCan as fasTrashCan,
  faTriangleExclamation as fasTriangleExclamation,
  faUpload as fasUpload,
  faUser as fasUser,
  faUsers as fasUsers,
  faXmark as fasXmark,
  faToggleOff,
  faUserPlus,
  faUserSecret,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons';
import {
  faArrowLeftToLine,
  faArrowRightToLine,
  faArrowUpRightFromSquare,
  faChartTreeMap,
  faDownLeftAndUpRightToCenter,
  faGrid2,
  faLocationCheck,
  faPersonToPortal,
  faRocketLaunch,
  faCircleInfo as fasCircleInfo,
  faShuffle,
  faPaperclipVertical as fasPaperclipVertical,
  faStars,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faBell,
  faBellSlash,
  faCheckCircle,
  faClock,
  faCopy,
  faEye,
  faEyeSlash,
  faCalendar as farCalendar,
  faCircleQuestion as farCircleQuestion,
  faCircleXmark as farCircleXmark,
  faComment as farComment,
  faFileLines as farFileLines,
  faNewspaper as farNewspaper,
  faSave as farSave,
  faSquareCheck as farSquareCheck,
  faThumbsUp,
} from '@fortawesome/free-regular-svg-icons';
import {
  faAlarmClock,
  faArrowRightToBracket,
  faBarsFilter,
  faBath,
  faBed,
  faBold,
  faBoxesStacked,
  faCalculator,
  faCamera,
  faCheckToSlot,
  faCirclePlus,
  faClockRotateLeft,
  faCloudSun,
  faColumns3,
  faCommentSlash,
  faCompass,
  faDiagramNested,
  faExternalLink,
  faFileArrowUp,
  faFileSlash,
  faFilterSlash,
  faFireFlameSimple,
  faFlag,
  faFlagCheckered,
  faGear,
  faGridHorizontal,
  faGripDotsVertical,
  faGripLines,
  faHeat,
  faHighlighter,
  faHourglass,
  faHouseCircleCheck,
  faImage,
  faItalic,
  faListOl,
  faListTimeline,
  faLockOpen,
  faMagnifyingGlass,
  faMemo,
  faMobile,
  faNote,
  faPalette,
  faPen,
  faPercentage,
  faPersonDolly,
  faPhone,
  faQrcode,
  faArrowDownWideShort as farArrowDownWideShort,
  faArrowLeft as farArrowLeft,
  faArrowRight as farArrowRight,
  faBars as farBars,
  faBolt as farBolt,
  faBuilding as farBuilding,
  faCalendarCheck as farCalendarCheck,
  faCheck as farCheck,
  faCheckDouble as farCheckDouble,
  faChevronDown as farChevronDown,
  faChevronRight as farChevronRight,
  faCircleInfo as farCircleInfo,
  faClipboardList as farClipboardList,
  faCreditCard as farCreditCard,
  faEllipsis as farEllipsis,
  faEllipsisVertical as farEllipsisVertical,
  faEnvelope as farEnvelope,
  faExclamationCircle as farExclamationCircle,
  faFolderOpen as farFolderOpen,
  faHandshake as farHandshake,
  faHouse as farHouse,
  faHouseChimneyHeart as farHouseChimneyHeart,
  faInfo as farInfo,
  faLayerGroup as farLayerGroup,
  faLightbulb as farLightbulb,
  faLink as farLink,
  faList as farList,
  faListCheck as farListCheck,
  faLocationDot as farLocationDot,
  faLock as farLock,
  faMinus as farMinus,
  faRotateLeft,
  faRotateRight,
  faPaperclipVertical as farPaperclipVertical,
  faPenToSquare as farPenToSquare,
  faPlus as farPlus,
  faReceipt as farReceipt,
  faSignsPost as farSignsPost,
  faTag as farTag,
  faTimeline as farTimeline,
  faTrashCan as farTrashCan,
  faTriangleExclamation as farTriangleExclamation,
  faRuler,
  faUpload as farUpload,
  faUser as farUser,
  faUserPlus as farUserPlus,
  faUsers as farUsers,
  faXmark as farXmark,
  faSignature,
  faSliders,
  faStar,
  faStrikethrough,
  faThumbtack,
  faUnderline,
  faUnlock,
  faUserGroup,
  faUserHelmetSafety,
  faVideo,
  faWater,
} from '@fortawesome/pro-regular-svg-icons';
import { faFilePlus } from '@fortawesome/pro-light-svg-icons';
import { faCalendarCheck as fadCalendarCheck, faSadTear } from '@fortawesome/pro-duotone-svg-icons';

// WhatsApp Web's double-tick shape, captured at https://stackoverflow.com/questions/53053885/.
const whatsappCheckDouble = {
  prefix: 'far',
  iconName: 'whatsapp-check-double',
  icon: [
    16,
    15,
    [],
    '',
    'M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z',
  ],
};

const APP_ICONS = Object.freeze({
  'duotone-calendar-check': fadCalendarCheck,
  'duotone-sad-tear': faSadTear,
  'light-file-plus': faFilePlus,
  'regular-alarm-clock': faAlarmClock,
  'regular-arrow-down-wide-short': farArrowDownWideShort,
  'regular-arrow-left': farArrowLeft,
  'regular-arrow-right': farArrowRight,
  'regular-arrow-right-to-bracket': faArrowRightToBracket,
  'regular-arrow-up-right-from-square': faExternalLink,
  'regular-bars': farBars,
  'regular-bars-filter': faBarsFilter,
  'regular-bath': faBath,
  'regular-bed': faBed,
  'regular-bell': faBell,
  'regular-bell-slash': faBellSlash,
  'regular-bold': faBold,
  'regular-bolt': farBolt,
  'regular-boxes-stacked': faBoxesStacked,
  'regular-building': farBuilding,
  'regular-calculator': faCalculator,
  'regular-calendar': farCalendar,
  'regular-calendar-check': farCalendarCheck,
  'regular-camera': faCamera,
  'regular-check': farCheck,
  'regular-check-double': farCheckDouble,
  'regular-check-to-slot': faCheckToSlot,
  'regular-chevron-down': farChevronDown,
  'regular-chevron-right': farChevronRight,
  'regular-circle-check': faCheckCircle,
  'regular-circle-exclamation': farExclamationCircle,
  'regular-circle-info': farCircleInfo,
  'regular-circle-plus': faCirclePlus,
  'regular-circle-question': farCircleQuestion,
  'regular-circle-xmark': farCircleXmark,
  'regular-clipboard-list': farClipboardList,
  'regular-clock': faClock,
  'regular-clock-rotate-left': faClockRotateLeft,
  'regular-cloud-sun': faCloudSun,
  'regular-columns-3': faColumns3,
  'regular-comment': farComment,
  'regular-comment-slash': faCommentSlash,
  'regular-compass': faCompass,
  'regular-copy': faCopy,
  'regular-credit-card': farCreditCard,
  'regular-diagram-nested': faDiagramNested,
  'regular-ellipsis': farEllipsis,
  'regular-ellipsis-vertical': farEllipsisVertical,
  'regular-envelope': farEnvelope,
  'regular-eye': faEye,
  'regular-eye-slash': faEyeSlash,
  'regular-file-arrow-up': faFileArrowUp,
  'regular-file-lines': farFileLines,
  'regular-file-slash': faFileSlash,
  'regular-filter-slash': faFilterSlash,
  'regular-fire-flame-simple': faFireFlameSimple,
  'regular-flag': faFlag,
  'regular-flag-checkered': faFlagCheckered,
  'regular-floppy-disk': farSave,
  'regular-folder-open': farFolderOpen,
  'regular-gear': faGear,
  'regular-grid-horizontal': faGridHorizontal,
  'regular-grip-dots-vertical': faGripDotsVertical,
  'regular-grip-lines': faGripLines,
  'regular-handshake': farHandshake,
  'regular-heat': faHeat,
  'regular-highlighter': faHighlighter,
  'regular-hourglass': faHourglass,
  'regular-house': farHouse,
  'regular-house-chimney-heart': farHouseChimneyHeart,
  'regular-house-circle-check': faHouseCircleCheck,
  'regular-image': faImage,
  'regular-info': farInfo,
  'regular-italic': faItalic,
  'regular-layer-group': farLayerGroup,
  'regular-lightbulb': farLightbulb,
  'regular-link': farLink,
  'regular-list': farList,
  'regular-list-check': farListCheck,
  'regular-list-ol': faListOl,
  'regular-list-timeline': faListTimeline,
  'regular-location-dot': farLocationDot,
  'regular-lock': farLock,
  'regular-lock-open': faLockOpen,
  'regular-magnifying-glass': faMagnifyingGlass,
  'regular-memo': faMemo,
  'regular-minus': farMinus,
  'regular-mobile': faMobile,
  'regular-newspaper': farNewspaper,
  'regular-note': faNote,
  'regular-palette': faPalette,
  'regular-paperclip-vertical': farPaperclipVertical,
  'regular-pen': faPen,
  'regular-pen-to-square': farPenToSquare,
  'regular-percent': faPercentage,
  'regular-percentage': faPercentage,
  'regular-person-dolly': faPersonDolly,
  'regular-phone': faPhone,
  'regular-plus': farPlus,
  'regular-qrcode': faQrcode,
  'regular-receipt': farReceipt,
  'regular-rotate-left': faRotateLeft,
  'regular-rotate-right': faRotateRight,
  'regular-ruler': faRuler,
  'regular-signature': faSignature,
  'regular-signs-post': farSignsPost,
  'regular-sliders': faSliders,
  'regular-square-check': farSquareCheck,
  'regular-star': faStar,
  'regular-strikethrough': faStrikethrough,
  'regular-tag': farTag,
  'regular-thumbs-up': faThumbsUp,
  'regular-thumbtack': faThumbtack,
  'regular-timeline': farTimeline,
  'regular-trash-can': farTrashCan,
  'regular-triangle-exclamation': farTriangleExclamation,
  'regular-underline': faUnderline,
  'regular-unlock': faUnlock,
  'regular-upload': farUpload,
  'regular-user': farUser,
  'regular-user-group': faUserGroup,
  'regular-user-helmet-safety': faUserHelmetSafety,
  'regular-user-large': farUser,
  'regular-user-plus': farUserPlus,
  'regular-users': farUsers,
  'regular-video': faVideo,
  'regular-water': faWater,
  'regular-whatsapp-check-double': whatsappCheckDouble,
  'regular-xmark': farXmark,
  'solid-angle-down': faAngleDown,
  'solid-angle-left': faAngleLeft,
  'solid-angle-right': faAngleRight,
  'solid-angle-up': faAngleUp,
  'solid-arrow-down': faArrowDown,
  'solid-arrow-down-wide-short': faArrowDownWideShort,
  'solid-arrow-left': fasArrowLeft,
  'solid-arrow-left-to-line': faArrowLeftToLine,
  'solid-arrow-right': fasArrowRight,
  'solid-arrow-right-to-line': faArrowRightToLine,
  'solid-arrow-up': faArrowUp,
  'solid-arrow-up-right-from-square': faArrowUpRightFromSquare,
  'solid-ban': faBan,
  'solid-bars': fasBars,
  'solid-bolt': fasBolt,
  'solid-building': fasBuilding,
  'solid-bullhorn': faBullhorn,
  'solid-calendar': fasCalendar,
  'solid-calendar-days': faCalendarDays,
  'solid-chart-bar': faChartBar,
  'solid-chart-tree-map': faChartTreeMap,
  'solid-check': fasCheck,
  'solid-check-double': faCheckDouble,
  'solid-chevron-down': fasChevronDown,
  'solid-chevron-left': faChevronLeft,
  'solid-chevron-right': fasChevronRight,
  'solid-chevron-up': faChevronUp,
  'solid-circle': faCircle,
  'solid-circle-exclamation': fasExclamationCircle,
  'solid-circle-info': fasCircleInfo,
  'solid-circle-minus': faCircleMinus,
  'solid-circle-question': fasCircleQuestion,
  'solid-circle-xmark': fasCircleXmark,
  'solid-code-branch': faCodeBranch,
  'solid-comment': fasComment,
  'solid-comments': faComments,
  'solid-compress': faCompress,
  'solid-credit-card': fasCreditCard,
  'solid-database': faDatabase,
  'solid-down-left-and-up-right-to-center': faDownLeftAndUpRightToCenter,
  'solid-download': faDownload,
  'solid-ellipsis': fasEllipsis,
  'solid-ellipsis-vertical': fasEllipsisVertical,
  'solid-envelope': fasEnvelope,
  'solid-envelope-open-text': faEnvelopeOpenText,
  'solid-expand': faExpand,
  'solid-face-laugh-beam': faLaughBeam,
  'solid-file': faFile,
  'solid-file-audio': faFileAudio,
  'solid-file-excel': faFileExcel,
  'solid-file-image': faFileImage,
  'solid-file-lines': fasFileLines,
  'solid-file-pdf': faFilePdf,
  'solid-file-powerpoint': faFilePowerpoint,
  'solid-file-signature': faFileSignature,
  'solid-file-video': faFileVideo,
  'solid-file-word': faFileWord,
  'solid-folder-open': fasFolderOpen,
  'solid-forward': faForward,
  'solid-grid-2': faGrid2,
  'solid-handshake': fasHandshake,
  'solid-house': fasHouse,
  'solid-images': faImages,
  'solid-info': fasInfo,
  'solid-layer-group': fasLayerGroup,
  'solid-link': fasLink,
  'solid-link-slash': faLinkSlash,
  'solid-list': fasList,
  'solid-location-check': faLocationCheck,
  'solid-location-dot': fasLocationDot,
  'solid-lock': fasLock,
  'solid-minus': fasMinus,
  'solid-paper-plane': faPaperPlane,
  'solid-paperclip-vertical': fasPaperclipVertical,
  'solid-pen-to-square': fasPenToSquare,
  'solid-person-to-portal': faPersonToPortal,
  'solid-plus': fasPlus,
  'solid-poll': faPoll,
  'solid-right-from-bracket': faRightFromBracket,
  'solid-robot': faRobot,
  'solid-rocket-launch': faRocketLaunch,
  'solid-save': fasSave,
  'solid-share': faShare,
  'solid-shuffle': faShuffle,
  'solid-spinner': faSpinner,
  'solid-stars': faStars,
  'solid-tag': fasTag,
  'solid-timeline': fasTimeline,
  'solid-toggle-off': faToggleOff,
  'solid-trash-can': fasTrashCan,
  'solid-triangle-exclamation': fasTriangleExclamation,
  'solid-up-right-and-down-left-from-center': faUpRightAndDownLeftFromCenter,
  'solid-upload': fasUpload,
  'solid-user': fasUser,
  'solid-user-plus': faUserPlus,
  'solid-user-secret': faUserSecret,
  'solid-users': fasUsers,
  'solid-warehouse': faWarehouse,
  'solid-xmark': fasXmark,
});

export default APP_ICONS;
